import { Assets } from "@/utils/assets";
import Phaser from "phaser";

export default class Life extends Phaser.GameObjects.Sprite{

    constructor(scene: Phaser.Scene){
        super(scene, 0, 0, Assets.GAME.ID, 'life_5.png');
        this.setOrigin(0,0.5);
        scene.add.existing(this);
    }

    public update(life:number): void{
        this.setFrame(`life_${life}.png`)
    }

}